import React, { Component } from 'react'
import PropTypes from 'prop-types';
import { compose } from 'redux'
import { connect } from 'react-redux'
import get from 'lodash/get'
import isEqual from 'lodash/isEqual'

// Comps
import Prompt from '../modals/Prompt'

function withPrompts(WrappedComponent) {
  return class PromptHOC extends Component {
    static propTypes = {
      prompt: PropTypes.any,
      promptVisible: PropTypes.any,
    };

    componentDidUpdate(prevProps){
      const
        prevPrompt = get(prevProps, 'notifications.prompt'),
        prevVisible = get(prevProps, 'notifications.promptVisible'),
        prompt = get(this, 'props.notifications.prompt'),
        visible = get(this, 'props.notifications.promptVisible');

      if (!isEqual(prompt, prevPrompt)) return true;
      if (!isEqual(visible, prevVisible)) return true;


    } // END componentDidUpdate

    render() {
      const { promptVisible, prompt } = this.props;
      return (
        <React.Fragment>
          <Prompt visible={ !!promptVisible } { ...prompt } />
          <WrappedComponent { ...this.props } />
        </React.Fragment>
      )

    } // END render

  } // END return class

} // END withPrompts


const mapStateToProps = state => ({
  promptVisible: state.notifications.promptVisible,
  prompt:        state.notifications.prompt

}) // END mapStateToProps


const composedWithPrompts = compose(
  connect(mapStateToProps, null),
  withPrompts
) // END composedWithPrompts


export default composedWithPrompts;


// WEBPACK FOOTER //
// ./src/helpers/PromptsHoc.js